export const UPDATE_LANDING_PAGE_FILTERS = 'UPDATE_LANDING_PAGE_FILTERS';
export const CLEAR_LANDING_PAGE_FILTERS = 'CLEAR_LANDING_PAGE_FILTERS';
export const UPDATE_SEARCH_VALUE = 'UPDATE_SEARCH_VALUE';
export const STORE_FILTER_API_RESPONSES = 'STORE_FILTER_API_RESPONSES';

export const updateLandingPageFilters = (data) => ({
  type: UPDATE_LANDING_PAGE_FILTERS,
  payload: data,
});

export const clearLandingPageFilters = () => ({
  type: CLEAR_LANDING_PAGE_FILTERS,
});

export const updateSearchValue = (searchValue) => ({
  type: UPDATE_SEARCH_VALUE,
  payload: searchValue,
});

export const storeFilterApiResponses = (data) => ({
  type: STORE_FILTER_API_RESPONSES,
  payload: data,
});
